/**
 * @Author: Jon Lucas
 * @Date:   2017-09-11T16:29:23+02:00
 * @Email:  jon.lucas@mazedia.fr
 * @Last modified by:   Jon Lucas
 * @Last modified time: 2017-09-25T17:37:57+02:00
 */
import {Component, OnInit} from "@angular/core";
import {Router, ActivatedRoute, NavigationEnd, UrlTree} from "@angular/router";
import {AppService} from "../app.service";
import {ServiceLocator} from "../service-locator";
import {ConfDataService} from "../conf-data.service";
import {AfterViewInit} from "@angular/core/src/metadata/lifecycle_hooks";
import {AppLoadingStateService} from "../app-loading-state.service";
import { environment } from "../../environments/environment";
import { LoaderUtils } from "../util/LoaderUtils";
import { ApiUtils } from "../util/ApiUtils";

@Component({
    selector: "app-main-header",
    templateUrl: "./main-header.component.html",
    styleUrls: ["./main-header.component.scss"]
})

export class MainHeaderComponent implements OnInit, AfterViewInit {

    public TAG = "[MainHeaderComponent]";

    protected appService: AppService;
    protected router: Router;
    protected confDataService: ConfDataService;

    public lang: string;

    public typeId: string;
    public subtypeId: string;
    public mainTitle: string;
    public mainSubtitle: string;

    public needAuthentication: boolean = false;
    public isAuthenticate: boolean = false;

    public grand_compte = environment.grandCompte;

    constructor(
        private route: ActivatedRoute, 
        private appLoadingStateService: AppLoadingStateService,
        private apiUtils: ApiUtils
    ) {
        this.appService = ServiceLocator.injector.get(AppService);
        this.router = ServiceLocator.injector.get(Router);
        this.confDataService = ServiceLocator.injector.get(ConfDataService);
        this.mainTitle = environment.main_title;
        this.mainSubtitle = environment.main_subtitle;
        this.needAuthentication = environment.need_authentication;
    }

    protected navigationStartEventHandler(e: NavigationEnd): void {
        // console.log(this.route.snapshot.children[0].paramMap.get("lang"));
        // console.log(this.TAG, this.router.url, this.route);
        const urlTree: UrlTree = this.router.parseUrl(this.router.url);
        if (urlTree.root.children.primary.segments[1].path === undefined) {
            return;
        }
        this.lang = urlTree.root.children.primary.segments[1] ? urlTree.root.children.primary.segments[1].path : undefined;
        this.typeId = urlTree.root.children.primary.segments[2] ? urlTree.root.children.primary.segments[2].path : undefined;
        this.subtypeId = urlTree.root.children.primary.segments[3] ? urlTree.root.children.primary.segments[3].path : "";
    }

    public setLang(pLang: string): void {
        this.lang = pLang;

        const commands: string[] = ["/lang", this.lang, this.typeId, this.subtypeId];

        this.router.navigate(commands);
    }

    public ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.lang = params.get("lang");
            console.log(this.TAG, "ngOnInit()", this.lang);
        });

        this.router.events
            .filter(event => event instanceof NavigationEnd)
            .subscribe(this.navigationStartEventHandler.bind(this));
    }

    public ngAfterViewInit(): void {
        this.appLoadingStateService.headerLoaded = true;
    }

    public isAuthorized(): boolean {
        let authorized = false;

        if (localStorage.getItem('authorized') !== null) {
            authorized = true;
        } else {
            authorized = !this.needAuthentication;
        }

        return authorized;
    }

    public resetValue(): void {
        this.confDataService.resetToDefault();

        const urlTree: UrlTree = this.router.parseUrl(this.router.url);
        const lang = urlTree.root.children.primary.segments[1].path;
        const commands: string[] = ["/lang", lang, "project-type-choice"];
        this.router.navigate(commands);

        window.location.href = window.location.href;
    }

    public saveActualConfiguration(): void {
        LoaderUtils.addLoader("draft-devis-loader", <HTMLElement>document.getElementById("app-container"), true);
        LoaderUtils.showLoader("draft-devis-loader");
        this.apiUtils.saveDraftDevis();
    }
}



// WEBPACK FOOTER //
// ./src/app/main-header/main-header.component.ts